import * as React from 'react';
import PrivacyContent from './Privacy.Content';

import './Privacy.page.scss';

export interface PrivacyProps {
}

export class PrivacyPage extends React.Component<PrivacyProps, any> {
  public render() {
    return (
      <div className="page-privacy pt-5 pb-5">
        <PrivacyContent />
      </div>
    );
  }
}
